import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logPostInfo, logging } from '../../actions/log';
import { CONTEXT } from '../../config';
import { getSearchRecommend } from '../../actions/search';
import ApkButton from '../Button/Button';
import Rate from '../Rate/Rate';
import styles from './ALineCard.module.less';
import { setIframeVisible } from '../../actions/layout';
import DEFAULTIMG from '../../static/default.svg';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const installedSoftInit = useSelector(selectInstalledSoft);
  const logInfoData = useSelector(selectLogInfo);

  const handleSoftBtn = useCallback(
    _soft => {
      const found = installedSoftInit.find(soft_ => soft_.packageName === _soft.packageName);
      if (!found) {
        dispatch(
          getSearchRecommend({
            softInfo: _soft.packageName,
            androidType: _soft.androidType || 1,
            source: logInfo.source,
          }),
        );
      }
    },
    [dispatch, installedSoftInit],
  );

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'LineCard_err';
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
        // bizInfo: soft_.bizInfo
      }),
    );
  }, [dispatch]);

  const handleShopping = url => () => {
    dispatch(
      setIframeVisible({
        visible: true,
        url,
        source: logInfo ? logInfo.source : 'LineCard_err',
      }),
    );
    dispatch(
      logging({
        category: 'C',
        action: 'Search_Buy_Text',
        label: '',
        param2: {
          source: logInfo ? logInfo.source : 'LineCard_err',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          softId: soft.packageName,
          softType: soft.androidType || 0,
          id: soft.merchandiseMap.sid,
          // id 商品id
          // softtype
        },
      }),
    );
  };

  // 搜索结果页-商品活动文字链展现
  useEffect(() => {
    if (soft && soft.merchandiseMap && soft.merchandiseMap.sid) {
      dispatch(
        logging({
          category: 'I',
          action: 'Search_Buy_Text',
          label: '',
          param2: {
            source: logInfo ? logInfo.source : 'LineCard_err',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word,
            softid: soft.packageName,
            softType: soft.androidType || 0,
            id: soft.merchandiseMap.sid,
            // id 商品id
            // softtype
          },
        }),
      );
    }
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.card_main}>
        <div className="app">
          <Link
            className="app_logo"
            to={{
              pathname: `${CONTEXT}/adetail/${soft.packageName}/${
                soft.versionCode
              }/${soft.bizInfo || '{}'}`,
            }}
            onClick={() => {
              handleSoftCard(soft);
            }}
          >
            <img className="logo" src={soft.logoFile || DEFAULTIMG} alt="" />
            <div className="alogo" />
          </Link>
          <div className="info">
            <div className="title_info">
              <Link
                className="title"
                to={{
                  pathname: `${CONTEXT}/adetail/${soft.packageName}/${
                    soft.versionCode
                  }/${soft.bizInfo || '{}'}`,
                }}
                onClick={() => {
                  handleSoftCard(soft);
                }}
                title={soft.softName}
              >
                {soft.softName}
                <span className="title_point"> - 手机版</span>
              </Link>
              {soft &&
                soft.searchTag &&
                soft.searchTag.map((item, i) => (
                  <img
                    className="table"
                    src={item.icon}
                    key={i}
                    alt={item.name || ''}
                    title={item.tips || ''}
                  />
                ))}
            </div>
            <Link
              className="desc"
              to={{
                pathname: `${CONTEXT}/adetail/${soft.packageName}/${
                  soft.versionCode
                }/${soft.bizInfo || '{}'}`,
              }}
              onClick={() => {
                handleSoftCard(soft);
              }}
              title={soft.introduction}
            >
              {soft.introduction}
              {/* 手机版可在电脑上直接安装 */}
            </Link>
          </div>
          <Link
            className="size"
            to={{
              pathname: `${CONTEXT}/adetail/${soft.packageName}/${
                soft.versionCode
              }/${soft.bizInfo || '{}'}`,
            }}
            onClick={() => {
              handleSoftCard(soft);
            }}
          >
            {soft.installFileSize}
          </Link>
          <div className="score">
            <Rate score={(Number(soft.score) / 20).toFixed(1)} />
            <span className="val">{(Number(soft.score) / 20).toFixed(1)}</span>
          </div>
        </div>

        <div className="opt">
          <div
            className="opt_div"
            onClick={() => {
              handleSoftBtn(soft);
            }}
          >
            <ApkButton
              soft={soft}
              info={{
                className: styles.soft_btn,
                className_busing: styles.soft_btn_busing,
                className_open: styles.soft_button_open,
              }}
              logInfo={logInfo}
            />
          </div>
        </div>
      </div>
      {soft.merchandiseMap && (
        <>
          <div className="ad" onClick={handleShopping(soft.merchandiseMap.merchandiseUrl)}>
            {soft.merchandiseMap.desc}&gt;
          </div>
          <div className="ad_arrow">&gt;</div>
        </>
      )}
    </div>
  );
});
